import { InspectType, ResultStatusType, ResultType } from '@/app/_types';

export const passwordRegex = new RegExp(
  /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()-_=+{}[\]:;"'<>,.?/`~\\|]+$/,
);

export const checkTypeLabels: Record<InspectType, string> = {
  bypass: 'AIバイパス',
  detect: 'AI検出',
};

export const resultLabels: Record<ResultType, string> = {
  danger: '危険',
  warning: '注意',
  safe: '安全',
  bypass: 'バイパス完了',
  failed: 'チェック不可',
  none: '-',
};

export const detailResultLabels: Record<ResultStatusType, string> = {
  completed: '結果確認',
  failed: 'FAQ確認',
  progress: 'チェック待機',
  pending: 'チェック中',
};

export const MAX_UPLOAD_SIZE = 100;
export const NOT_INPUT = '未入力';

export const MIN_TEXT_LENGTH = 200;
export const MAX_TEXT_LENGTH = 3_000;
export const MAX_TITLE_LENGTH = 100;

export const MID = 'myspace';

export const LINKS = {
  FAQ: 'https://manual.muhayu.com/gptkiller-jp',
  POLICY: 'https://manual.muhayu.com/gptkiller-jp/dokyumento/terms_of_use',
  PRIVACY: 'https://manual.muhayu.com/gptkiller-jp/dokyumento/privacy_policy',
  RESULT_FAQ: 'https://manual.muhayu.com/gptkiller-jp/common/chekkunohadousurebayoidesuka',
};

export const INVALID_TITLE_CHARS = /^[^<>:"/\\|?*]*$/;
